import { Container } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { PortalTransparansi } from '../../../components/PortalTransparansi'

export const Route = createFileRoute('/desa/$slug/transparansi')({
  component: TransparansiPage,
})

function TransparansiPage() {
  const { slug } = Route.useParams()
  useEffect(() => {
    const name = slug.replace(/-/g, ' ').replace(/\b\w/g, (c: string) => c.toUpperCase())
    document.title = `Transparansi Keuangan — Desa ${name}`
    return () => {
      document.title = 'Desa Platform — Asisten Digital Desa'
    }
  }, [slug])
  return (
    <Container size="lg" py="xl" px={{ base: 'md', sm: 'xl' }}>
      <PortalTransparansi slug={slug} />
    </Container>
  )
}
